/**
 * Minimal pub/sub, ported verbatim from yaqatw's src/service/events.ts.
 * The cloud provider files (ported from yaqatw) call `Events.emit("showStatus", ...)`
 * / `Events.emit("showError", ...)` throughout — kept unchanged from the source
 * so the provider ports stay near-verbatim. src/cloud/syncStatusStore.ts
 * subscribes to those two event names and is the only qda-side consumer.
 */
type Callback<T = unknown> = (payload?: T) => void;

class Events {
  private listeners: Record<string, Callback[]> = {};

  /** Register a listener for an event */
  on<T = unknown>(event: string, cb: Callback<T>) {
    if (!this.listeners[event]) this.listeners[event] = [];
    this.listeners[event].push(cb as Callback);
  }

  /** Remove a listener for an event */
  off<T = unknown>(event: string, cb: Callback<T>) {
    if (!this.listeners[event]) return;
    this.listeners[event] = this.listeners[event].filter((fn) => fn !== cb);
  }

  /** Trigger all listeners for an event */
  emit<T = unknown>(event: string, payload?: T) {
    if (!this.listeners[event]) return;
    this.listeners[event].forEach((cb) => cb(payload));
  }
}

const events = new Events();
export default events;
